import './CardHorizontal.css'

export default function CardHorizontal({title, text}) {
    return (
        <div className='cardHorizontal'>
            <h3>
                {title}
            </h3>
            <p>
                {text}
            </p>
        </div>
    )
}
